import { register, CloudObject, Tag, Transaction, defineProperty, defineRelation } from 'olympe';
import InspectionEntity from "./InspectionEntity";
import Aspect from "./Aspect";

/**
 * @extends {CloudObject}
 */
export default class AHPValue extends CloudObject {

    /**
     * Creates an instance of AHPValue.
     *
     * @param {!Transaction} transaction
     * @return {!string} the tag of the created instance
     */
    static create(transaction) {
        return transaction.create(AHPValue);
    }
    
    /**
     * @return {number}
     */
    getValue() {
        return this.get(AHPValue.valueProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<number>}
     */
    observeValue($) {
        return this.observe($, AHPValue.valueProp);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {number} value
     */
    static setValue(transaction, instance, value) {
        transaction.update(instance, AHPValue.valueProp, value);
    }

}

// Hardcoded tags
register('01880b4124bc6b0031f7', AHPValue);
AHPValue.valueProp = defineProperty('01880b415b67945e4de5');
AHPValue.aspectRel = defineRelation('01880b43842faecab448', AHPValue, Aspect);
AHPValue.itemRel = defineRelation('01894f173ae27a21840d', AHPValue, InspectionEntity);
